






















import { DashboardService } from "@/services/dashboard.service";
import dayjs from "dayjs";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({
})
export default class ConversaoLeadsCard extends Vue {
  taxaDeConversaoDeLeads: number | null = null;
  loading = false;

  @Prop() date!: string | null;
  mesAtual: string | null = null;

  mounted() {
    this.fetch();
  }

  @Watch("date") 
  fetch() {
    if (!this.date) {
      this.mesAtual = dayjs().format("YYYY-MM");
    } else {
      this.mesAtual = dayjs(this.date).format("YYYY-MM");
    }
    dayjs.locale("pt-br");

    this.carregarTaxaDeConversaoDeLeads();
  }

  async carregarTaxaDeConversaoDeLeads() {
    this.loading = true;
    if(this.mesAtual){
      this.taxaDeConversaoDeLeads = await DashboardService.TaxaDeConversaoDeLeads(
        this.mesAtual
      ).finally(() => (this.loading = false));
    }
  }
}
